import React, { useState } from 'react'
import clsx from 'clsx';
import { useSelector } from 'react-redux';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
// components
import Theme from '../../Theme.js';
import WidgetBar from '../../../../builder/components/WidgetBar.js'

// styles
const useStyles = makeStyles({
  avatar: {
    height: '3.25rem',
    width: '3.25rem',
    boxShadow: Theme.avatarBoxShadow,
  },
  card: {
    marginBottom: '1.75rem',
    boxShadow: Theme.cardBoxShadow,
    position: 'relative',
  },
  cardActions: {
    // justifyContent: 'space-evenly',
    padding: props => props.context.properties.show_comment ? '.5rem 1rem 1.5rem' : '1.5rem 1rem 1.5rem',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  },
  cardActionsButton: {
    minWidth: '250px',
  },
  cardComment: {
    alignItems: 'start',
  },
  cardCommentAvatar: {
    height: '2.5rem',
    width: '2.5rem',
    boxShadow: Theme.avatarBoxShadow,
  },
  cardCommentText: {
    display: 'flex',
    flexDirection: 'column',
    padding: '.5rem .625rem',
    background: Theme.bgColorMd,
    borderRadius: '18px',
    maxWidth: '400px',
    whiteSpace: 'pre-line',
    '& span': {
      marginRight: '3px',
      fontWeight: '500',
      fontSize: '.75rem',
      '&:last-child': {
        marginRight: '0px',
      }
    }
  },
  cardHeaderTitle: {
    fontSize: '.65rem',
    textTransform: 'uppercase',
  },
  cardHeaderSubTitle: {
    fontSize: '1rem',
    whiteSpace: 'pre-line',
  },
  commentCardHeaderContent: {
    flex: '0 1 auto',
  },
  customAuthor: {
    margin: '16px',
    padding: '0px',
  },
  customMessage: {
    margin: '16px',
    padding: '0px',
  },
});
 

export default function Custom(props) {
  const { context, screen } = props;
  const [showWidgetBar, setShowWidgetBar] = useState(false)
  const classes = useStyles(props);
  var order;
  (screen == 'desktop') ? (order = context.desktop_order) : (order = context.mobile_order);
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  if (window.mode == 'live') {
    var language = window.language;
  } else {
    var language = useSelector(state => state.language);
  };

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  return (
    <Card className={componentClasses + ` ${context.name.toLowerCase().replaceAll(' ', '-')}`} style={{ order: order }}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >

      {context["properties"]["show_author"] && (
      <CardHeader className={classes.customAuthor}
        avatar={
          <Avatar src={context.properties.author_image} className={classes.avatar}>
            {!context.properties.author_image &&
              context.properties.author_name.charAt(0)
            }
          </Avatar>
        }
        title={context["properties"]["author_title_" + language] && (context["properties"]["author_final"] == "guide") && (
          <Typography variant="caption" component="p" color="textSecondary" className={classes.cardHeaderTitle}>
            {context["properties"]["author_title_" + language]}
          </Typography>
        )}
        subheader={context["properties"]["show_author_name"] && (
          <Typography variant="h5" component="span" color="textPrimary" className={classes.cardHeaderSubTitle}>
            {context["properties"]["author_name"]}
          </Typography>
        )}
      />
      )}

      {context["properties"]["show_message"] && (
      <CardContent className={classes.customMessage}>
        <Typography gutterBottom variant="body1" component="h2" style={{ whiteSpace: 'pre-line' }} >
          {context["properties"]["message_" + language]}
        </Typography>
      </CardContent>
      )}

      {context["properties"]["show_image"] && context["properties"]["image_url"] && (
      <CardMedia
        // className={classes.media}
        component="img"
        image={context["properties"]["image_url"]}
      />
      )}

      {context.properties.show_comment && (

      <CardHeader
        classes={{
          content: classes.commentCardHeaderContent,
        }}
        className={classes.cardComment}
        avatar={
          <Avatar src={context.properties.comment_author_image} className={classes.cardCommentAvatar}>
            {!context.properties.comment_author_image &&
              context.properties.comment_author_name.charAt(0)
            }
          </Avatar>
        }
        subheader={
          <div className={classes.cardCommentText}>
            <div>
            {(context.properties.comment_author_final == "guide") && context.properties["comment_author_title_" + language] &&
              <Typography variant="body2" color="textPrimary" component="span">
                {context.properties["comment_author_title_" + language]}
              </Typography>
            }
            <Typography variant="body2" color="textPrimary" component="span">
              {context.properties.comment_author_name}
            </Typography>
            </div>
            {context.properties["comment_" + language]}
          </div>
        }
      />
      
      )}

      {context.properties.show_button && context.properties["button_text_" + language] && context.properties.button_link.trim() && (
      <CardActions className={classes.cardActions} >
        <Button variant="outlined" size="large" color="primary"
          className={classes.cardActionsButton}
          target="_blank" rel="noopener" href={context["properties"]["button_link"]}
        >
          {context["properties"]["button_text_" + language]}
        </Button>
      </CardActions>
      )}

      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }

    </Card>
  )
}
  